import Swiper from 'swiper';
import { Navigation, Pagination, Mousewheel, Controller } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default (el) => {
	const contents = el.querySelectorAll('.js-strate-selected-works-item-content');
	var current = 0;

	const set = (i) => {
		contents.forEach((content, j) => {
			if (j == i) {
				content.classList.add('active');
			}

			else if (j == current) {
				content.classList.add('inactive');
				setTimeout(() => {
					content.classList.remove('active');
					content.classList.remove('inactive');
				}, 500)
			}

			else {
				content.classList.remove('active');
			}
		})

		current = i;
	}

	const prev = el.querySelector('.js-strate-selected-works-prev');
	const next = el.querySelector('.js-strate-selected-works-next');
	const slider_main = el.querySelector('.js-selected-works-slider-main');
	const slider_secondary = el.querySelector('.js-selected-works-slider-secondary');

	const swiper1 = new Swiper(slider_main, {
		modules: [Navigation, Pagination, Mousewheel, Controller],
		spaceBetween: 20,
		grabCursor: true,
		slidesPerView: 1.25,
		loop: true,
		speed: 1000,
		loopAdditionalSlides: 5,
		breakpoints: {
		    768: {
		        slidesPerView: 1.5,
				// spaceBetween: 20
		    },
		    1200: {
		        slidesPerView: 1,
				// spaceBetween: 20
		    },
		},
		navigation: {
		    nextEl: next,
		    prevEl: prev,
		},
		mousewheel: {
			forceToAxis: true,
			releaseOnEdges: true
		},
		on: {
			slideChange: function () {
				set(this.realIndex);

				// var active = el.querySelector(`.swiper-slide[data-swiper-slide-index="${this.realIndex}"]`);
				// if (!active) {
				// 	active = this.slides[this.realIndex];
				// }
				// const slides = el.querySelectorAll('.swiper-slide');
				// slides.forEach((slide, i) => {
				// 	const position = slide.compareDocumentPosition(active); 

				// 	if (position & Node.DOCUMENT_POSITION_FOLLOWING) { 
				// 		slide.classList.add('prev');
				// 	} else if (position & Node.DOCUMENT_POSITION_PRECEDING) { 
				// 	    slide.classList.remove('prev');
				// 	} else { 
				// 	} 
				// });
			},
		}
	});


	const swiper2 = new Swiper(slider_secondary, {
		modules: [Navigation, Pagination, Mousewheel, Controller],
		spaceBetween: 20,
		grabCursor: true,
		slidesPerView: 1,
		loop: true,
		loopAdditionalSlides: 5,
		// centeredSlides: true,
		// initialSlide: 1,
		speed: 1000,
		// breakpoints: {
		//     768: {
		//         slidesPerView: 1.5,
		// 		// spaceBetween: 20
		//     },
		//     1200: {
		//         slidesPerView: 6,
		// 		// spaceBetween: 20
		//     },
		// },
		// navigation: {
		//     nextEl: next,
		//     prevEl: prev,
		// },
		mousewheel: {
			forceToAxis: true,
			releaseOnEdges: true
		},
		on: {
			slideChange: function () {
				// set(this.realIndex);

				// var active = el.querySelector(`.swiper-slide[data-swiper-slide-index="${this.realIndex}"]`);
				// if (!active) {
				// 	active = this.slides[this.realIndex];
				// }
				// const slides = el.querySelectorAll('.swiper-slide');
				// slides.forEach((slide, i) => {
				// 	const position = slide.compareDocumentPosition(active); 

				// 	if (position & Node.DOCUMENT_POSITION_FOLLOWING) { 
				// 		slide.classList.add('prev');
				// 	} else if (position & Node.DOCUMENT_POSITION_PRECEDING) { 
				// 	    slide.classList.remove('prev');
				// 	} else { 
				// 	} 
				// });
			},
		}
	});

	// swiper1.on('slideChange', function (e) {
	// 	swiper2.slideTo(swiper1.activeIndex + 1);
	// });

	// swiper2.on('slideChange', function (e) {
	// 	swiper1.slideTo(swiper2.activeIndex - 1);
	// });

	swiper1.controller.control = swiper2;
	swiper2.controller.control = swiper1;
};